"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessorType = void 0;
var ProcessorType;
(function (ProcessorType) {
    ProcessorType["Validate"] = "validate";
    ProcessorType["Custom"] = "custom";
})(ProcessorType || (exports.ProcessorType = ProcessorType = {}));
